import { MouseEvent, FC, useState } from 'react';
import { MaskedInput } from '@servicetitan/form';
import { ActionMenu, Button, Icon, InputProps, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';

import * as Styles from './user-phone-input.module.scss';
import { UserPhone, UserPhoneCountryCode } from '../../api/account-settings.api';
import { CountryFlag } from '../../../common/components/country-flag/country-flag';
import { UserPhoneConfig } from '../../constants/user-phone-config';

interface UserPhoneInputProps extends Omit<InputProps, 'value'> {
    value: UserPhone;
    onChange(value: UserPhone): void;
}

export const UserPhoneInput: FC<UserPhoneInputProps> = props => {
    const [isOpen, setIsOpen] = useState(false);

    const handleInputChange = (value: string) => {
        props.onChange({ ...props.value, phone: value });
    };

    const handleCodeChange = (value: UserPhoneCountryCode) => {
        props.onChange({ phone: '', countryCode: value });
    };

    return (
        <MaskedInput
            {...props}
            mask={UserPhoneConfig[props.value.countryCode].format}
            value={props.value.phone}
            onChange={handleInputChange}
            className={classNames(props.className, Styles.phoneInput, {
                [Styles.phoneInputDisabled]: props.disabled,
            })}
            placeholder={UserPhoneConfig[props.value.countryCode].placeholder}
            large
            shortLabel={
                <ActionMenu
                    portal
                    open={isOpen}
                    width="s"
                    direction="br"
                    onClickOutside={() => setIsOpen(false)}
                    trigger={
                        <Button
                            iconPosition="right"
                            large
                            icon={<Icon size={16} name={isOpen ? 'expand_less' : 'expand_more'} />}
                            onClick={(e: MouseEvent) => {
                                e.stopPropagation();
                                setIsOpen(!isOpen);
                            }}
                            className="border-radius-0"
                        >
                            <CountryFlag
                                alt={props.value.countryCode.toString()}
                                src={UserPhoneConfig[props.value.countryCode].flag}
                            />
                        </Button>
                    }
                >
                    {Object.entries(UserPhoneConfig).map(([key, item]) => (
                        <ActionMenu.Item
                            key={key}
                            onClick={(e: MouseEvent) => {
                                setIsOpen(false);
                                e.stopPropagation();
                                handleCodeChange(key as unknown as UserPhoneCountryCode);
                            }}
                        >
                            <Stack alignItems="center">
                                <Stack.Item>
                                    <CountryFlag alt={item.name} src={item.flag} />
                                </Stack.Item>
                                <Stack.Item className="m-l-1">{item.name}</Stack.Item>
                            </Stack>
                        </ActionMenu.Item>
                    ))}
                </ActionMenu>
            }
            shortLabelPosition="left"
        />
    );
};
